import { StatusBanner, Text } from "@wayflyer/flyui";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useSearchParams } from "react-router";
import { dataSourceSlugToName, FACEBOOK_SLUG } from "../../data-sources";

import type { OAuthErrorMessage } from "../messages";
import { MESSAGES, OAUTH_ERROR_MESSAGES } from "../messages";

export const OAuthErrorBanner = ({ connectorSlug }: { connectorSlug: string }) => {
  const intl = useIntl();
  const [searchParams] = useSearchParams();
  const oAuthError = searchParams.get("oauth-error");
  const errorMessageFromOAuthKey = (() => {
    // Customer came back from OAuth flow via third party platform back button
    if (oAuthError) {
      if (oAuthError === "no_accounts" && connectorSlug === FACEBOOK_SLUG) {
        return intl.formatMessage({
          id: "funding-application: reconnection - facebook no ad accounts",
          defaultMessage:
            "We couldn't find any Facebook Ad Accounts associated with the Facebook profile you connected. Please log in with a Facebook profile that has access to the Ad Accounts you want to connect.",
        });
      }
      const messageKey = oAuthError in OAUTH_ERROR_MESSAGES ? oAuthError : "default";
      return intl.formatMessage(OAUTH_ERROR_MESSAGES[messageKey as OAuthErrorMessage], {
        dataSourceName: dataSourceSlugToName(connectorSlug),
      });
    } else {
      return undefined;
    }
  })();
  const [error] = useState(errorMessageFromOAuthKey);

  const bannerBody = (
    <>
      <Text>
        {intl.formatMessage(MESSAGES.oauthErrorBannerWeEncountered)} {error}
      </Text>
      <Text>{intl.formatMessage(MESSAGES.oauthErrorBannerTryAgain)}</Text>
    </>
  );

  return (
    error && (
      <StatusBanner
        title={intl.formatMessage(MESSAGES.oauthErrorBannerTitle)}
        subheading={bannerBody}
        variant="critical"
      />
    )
  );
};
